import React from "react";
import useOutsideClickHandler from '../../components/base/useOutsideClickHandler';
export default useOutsideClickHandler;